// Mirrors backend routers/school.py holiday_reason() for instant UI feedback.
// The server is still authoritative (POST /school/attendance returns 409).

const isoDate = (d) => d.toISOString().slice(0, 10);

/** first & last calendar date of the month containing `dateStr` (YYYY-MM-DD). */
export function monthBounds(dateStr) {
  const d = new Date((dateStr || isoDate(new Date())) + "T00:00:00");
  const y = d.getFullYear();
  const m = d.getMonth();
  return [isoDate(new Date(y, m, 1)), isoDate(new Date(y, m + 1, 0))];
}

export function isSecondSaturday(d) {
  return d.getDay() === 6 && d.getDate() >= 8 && d.getDate() <= 14;
}

/** @returns {string|null} reason the date is a non-working day, or null */
export function holidayReason(dateStr, customMap = {}, rules = { sundays: true, second_saturday: true }) {
  if (!dateStr) return null;
  if (customMap[dateStr]) return customMap[dateStr];
  const d = new Date(dateStr + "T00:00:00");
  if (rules.sundays !== false && d.getDay() === 0) return "Sunday";
  if (rules.second_saturday !== false && isSecondSaturday(d)) return "2nd Saturday";
  return null;
}
